// extracted by mini-css-extract-plugin
module.exports = {"container":"FamilyPromoCard_container__XbXAN","list":"FamilyPromoCard_list__1jFaq","buttons":"FamilyPromoCard_buttons__e7KeH"};